module.exports = __webpack_public_path__ + "img/veeam_280x120.cd6688bd.svg";